/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamMatch
 */
export interface OWGameSteamMatch {
    /**
     * Confidence score of the match
     * @type {number}
     * @memberof OWGameSteamMatch
     */
    confidence?: number;
    /**
     * Method used for matching
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    method?: string;
    /**
     * Overwolf game name
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    overwolfName?: string;
    /**
     * Steam game name
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    steamName?: string;
}

/**
 * Check if a given object implements the OWGameSteamMatch interface.
 */
export function instanceOfOWGameSteamMatch(value: object): value is OWGameSteamMatch {
    return true;
}

export function OWGameSteamMatchFromJSON(json: any): OWGameSteamMatch {
    return OWGameSteamMatchFromJSONTyped(json, false);
}

export function OWGameSteamMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'method': json['method'] == null ? undefined : json['method'],
        'overwolfName': json['overwolfName'] == null ? undefined : json['overwolfName'],
        'steamName': json['steamName'] == null ? undefined : json['steamName'],
    };
}

export function OWGameSteamMatchToJSON(json: any): OWGameSteamMatch {
    return OWGameSteamMatchToJSONTyped(json, false);
}

export function OWGameSteamMatchToJSONTyped(value?: OWGameSteamMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confidence': value['confidence'],
        'method': value['method'],
        'overwolfName': value['overwolfName'],
        'steamName': value['steamName'],
    };
}

